<template>
  <div>
    <img
      v-if="Number.isInteger(obj)"
      :src="'/api/files/' + resources.texturesById[obj].file.physicalName"
      class="imgOrTile"
    />
    <canvas v-else class="imgOrTile" ref="canvas" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import drawHelpers from '@/api/training/defaults/draw_helpers'

export default {
  name: 'ImgOrTile',
  props: {
    obj: {
      required: true
    }
  },
  mounted() {
    if (!Number.isInteger(this.obj)) {
      const ctx = this.$refs.canvas.getContext('2d')
      const tile = this.resources.tilesets[this.obj.tileset].item(this.obj)
      const coords = {
        x: 0,
        y: 0,
        h: Math.min(this.$refs.canvas.height, tile.sourceSize.h),
        w: Math.min(this.$refs.canvas.width, tile.sourceSize.w)
      }
      drawHelpers.drawTile(ctx, coords, this.obj, { resources: this.resources })
    }
  },
  computed: {
    ...mapGetters({
      resources: 'training/getResources'
    })
  }
}
</script>

<style scoped>
.imgOrTile {
  max-width: 100%;
  height: auto !important;
}
</style>
